import React from 'react';
import { useState, useContext, useEffect } from 'react';
import * as Api from '../../../api/Api';
import { useQuery } from 'react-query';
import * as Utilities from '../../../Components/Utils/Utils';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Loading } from "../../../Components/Loading/Loading";
import { ErrorConnection } from "../../../Components/Error/Error";
import * as KeyNames from '../../../api/KeyNames';
import Tooltip from '../../../Components/Message/Tooltip';

export default function IndicadoresVentas({ idLocatario }) {

    let [indicadoresVentas, setIndicadoresVentas] = useState(
        {
            "date": "",
            "ventas": {
                "ventaDia": {
                    "value": 0,
                    "variation": 0
                },
                "ventaPromedioxRubro": {
                    "value": 0,
                    "variation": 0
                },
                "diferencia": {
                    "value": 0,
                    "variation": 0
                }
            },
            "ventasM2": {
                "ventaDiaM2": {
                    "value": 0,
                    "variation": 0
                },
                "ventaPromedioxRubroM2": {
                    "value": 0,
                    "variation": 0
                },
                "diferencia": {
                    "value": 0,
                    "variation": 0
                }
            }
        }
    );

    const token = useGetToken();

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data, isLoading, isError } = useQuery([KeyNames.SessionData, {
        api: "DashboardIndicadoresVentas",
        idLocatario: idLocatario,
        token: token
    }],
        async () => await Api.DashboardIndicadoresVentas({ "idLocatario": idLocatario, "token": token })
    );

    useEffect(() => {
        if (data) {
            if (/* !data.success || */data.data === null) { // 2do release. El data.success sirve para ver si la consulta da o no resultado, así que no se valida aquí.
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            } else if (data.data) {
                setIndicadoresVentas(data.data);
            }
        }
    }, [data]);

    if (isLoading || isLoading) return (<Loading />)
    if (isError || isError) return (<ErrorConnection error={isError/*.response.status*/} />)

    return (
        <div className="row g-5 g-xl-8">

            <div className="col-xl-4">
                <div className="card ">
                    <div className="card-body">
                        <div className="d-flex flex-stack mb-2">
                            <h3 className="card-label fw-bolder fs-5 mb-1">Venta del día</h3>
                            <div className='d-flex flex-column text-end'>
                                <span className="text-muted fw-bold fs-7">{(!indicadoresVentas.date) ? '' : indicadoresVentas.date}</span>
                            </div>
                        </div>
                        <div className="d-flex text-center flex-column text-dark pt-2">
                            <div className="d-flex align-items-end justify-content-center pt-2">
                                <div className='fw-bolder fs-5 text-gray-800 pe-1'>S/</div>
                                <span className="fw-bolder fs-3 pt-1 heading-banner">{(!indicadoresVentas.ventas) ? 0 : Utilities.formateoCifras(indicadoresVentas.ventas.ventaDia.value)} </span>
                                <div className="">
                                    {(!indicadoresVentas.ventas) ? 0 : Utilities.setClassVariationDashboard(indicadoresVentas.ventas.ventaDia.variation)}
                                    <Tooltip message={"Vs Día Anterior"}></Tooltip>
                                </div>

                            </div>
                        </div>
                    </div></div>
            </div>

            <div className="col-xl-4">
                <div className="card ">
                    <div className="card-body">
                        <div className="d-flex flex-stack mb-2">
                            <h3 className="card-label fw-bolder fs-5 mb-1">Venta Rubro</h3>
                            <div className='d-flex flex-column text-end'>
                                <span className="text-muted fw-bold fs-7">{(!indicadoresVentas.date) ? '' : indicadoresVentas.date}</span>
                            </div>
                        </div>
                        <div className="d-flex text-center flex-column text-dark pt-2">
                            <div className="d-flex align-items-end justify-content-center pt-2">
                                <div className='fw-bolder fs-5 text-gray-800 pe-1'>S/</div>
                                <span className="fw-bolder fs-3 pt-1 heading-banner">{(!indicadoresVentas.ventas) ? 0 : Utilities.formateoCifras(indicadoresVentas.ventas.ventaPromedioxRubro.value)} </span>
                                <div className="">
                                    {(!indicadoresVentas.ventas) ? 0 : Utilities.setClassVariationDashboard(indicadoresVentas.ventas.ventaPromedioxRubro.variation)}
                                    <Tooltip message={"Vs Día Anterior"}></Tooltip>
                                </div>

                            </div>
                        </div>
                    </div></div>
            </div>

            <div className="col-xl-4">
                <div className="card bg-danger-mall">
                    <div className="card-body">
                        <div className="d-flex flex-stack mb-2">
                            <h3 className="card-label fw-bolder fs-5 mb-1 text-red-mall">Diferencia</h3>
                            <div className='d-flex flex-column text-end'>
                                <span className="text-red-mall fw-bold fs-7">{(!indicadoresVentas.date) ? '' : indicadoresVentas.date}</span>
                            </div>
                        </div>
                        <div className="d-flex text-center flex-column text-red-mall pt-2">
                            <div className="d-flex align-items-center justify-content-center pt-2">
                                <div className='fw-bolder fs-5 text-red-mall pe-1'>S/</div>
                                <span className="fw-bolder fs-3 pt-1 heading-banner">{(!indicadoresVentas.date) ? 0 : Utilities.formateoCifras(indicadoresVentas.ventas.diferencia.value)}</span>
                                <div className="">
                                    {(!indicadoresVentas.date) ? 0 : Utilities.setClassVariationDashboard(indicadoresVentas.ventas.diferencia.variation)}
                                    <Tooltip message={"Vs Día Anterior"}></Tooltip>
                                </div>

                            </div>
                        </div>
                    </div></div>
            </div>


            <div className="col-xl-4">
                <div className="card ">
                    <div className="card-body">
                        <div className="d-flex flex-stack mb-2">
                            <h3 className="card-label fw-bolder fs-5 mb-1">Venta m<sup>2</sup></h3>
                            <div className='d-flex flex-column text-end'>
                                <span className="text-muted fw-bold fs-7">{(!indicadoresVentas.date) ? '' : indicadoresVentas.date}</span>
                            </div>
                        </div>
                        <div className="d-flex text-center flex-column text-dark pt-2">
                            <div className="d-flex align-items-end justify-content-center pt-2">
                                <div className='fw-bolder fs-5 text-gray-800 pe-1'>S/</div>
                                <span className="fw-bolder fs-3 pt-1 heading-banner">{(!indicadoresVentas.ventasM2) ? 0 : Utilities.formateoCifras(indicadoresVentas.ventasM2.ventaDiaM2.value)} </span>
                                <div className="">
                                    {(!indicadoresVentas.ventasM2) ? 0 : Utilities.setClassVariationDashboard(indicadoresVentas.ventasM2.ventaDiaM2.variation)}
                                    <Tooltip message={"Vs Día Anterior"}></Tooltip>
                                </div>

                            </div>
                        </div>
                    </div></div>
            </div>

            <div className="col-xl-4">
                <div className="card ">
                    <div className="card-body">
                        <div className="d-flex flex-stack mb-2">
                            <h3 className="card-label fw-bolder fs-5 mb-1">Vta Rubro m<sup>2</sup></h3>
                            <div className='d-flex flex-column text-end'>
                                <span className="text-muted fw-bold fs-7">{(!indicadoresVentas.date) ? '' : indicadoresVentas.date}</span>
                            </div>
                        </div>
                        <div className="d-flex text-center flex-column text-dark pt-2">
                            <div className="d-flex align-items-end justify-content-center pt-2">
                                <div className='fw-bolder fs-5 text-gray-800 pe-1'>S/</div>
                                <span className="fw-bolder fs-3 pt-1 heading-banner">{(!indicadoresVentas.ventasM2) ? 0 : Utilities.formateoCifras(indicadoresVentas.ventasM2.ventaPromedioxRubroM2.value)} </span>
                                <div className="">
                                    {Utilities.setClassVariationDashboard((!indicadoresVentas.ventasM2) ? 0 : indicadoresVentas.ventasM2.ventaPromedioxRubroM2.variation)}
                                    <Tooltip message={"Vs Día Anterior"}></Tooltip>
                                </div>

                            </div>
                        </div>
                    </div></div>
            </div>

            <div className="col-xl-4">
                <div className="card bg-light-blue">
                    <div className="card-body">
                        <div className="d-flex flex-stack mb-2">
                            <h3 className="card-label fw-bolder fs-5 mb-1 text-blue">Diferencia m<sup>2</sup></h3>
                            <div className='d-flex flex-column text-end'>
                                <span className="text-blue fw-bold fs-7">{(!indicadoresVentas.date) ? '' : indicadoresVentas.date}</span>
                            </div>
                        </div>
                        <div className="d-flex text-center flex-column text-blue pt-2">
                            <div className="d-flex align-items-center justify-content-center pt-2">
                                <div className='fw-bolder fs-5 text-blue pe-1'>S/</div>
                                <span className="fw-bolder fs-3 pt-1 heading-banner">{(!indicadoresVentas.ventasM2) ? 0 : Utilities.formateoCifras(indicadoresVentas.ventasM2.diferencia.value)}</span>
                                <div className="">
                                    {(!indicadoresVentas.ventasM2) ? 0 : Utilities.setClassVariationDashboard(indicadoresVentas.ventasM2.diferencia.variation)}
                                    <Tooltip message={"Vs Día Anterior"}></Tooltip>
                                </div>

                            </div>
                        </div>
                    </div></div>
            </div>

        </div >
    )
}
